// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"V6-z"};